import { useEffect, useRef, useState } from 'react';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

// helpers
import { canGoBack } from 'shared/helpers/history';

const DEEPLINK_TOAST_COUNT_KEY = 'deeplink_toast_count';
const DEEPLINK_TOAST_TIMESTAMP_KEY = 'deeplink_toast_timestamp';
const DEEPLINK_TOAST_PERIOD_COUNT_KEY = 'deeplink_toast_period_count';

function useDeeplinkToast() {
  const deeplinkToastConfig = useRemoteConfig('deeplinkToast');
  const [showToast, setShowToast] = useState(false);
  const hasChecked = useRef(false);

  useEffect(() => {
    if (hasChecked.current) {
      return;
    }
    hasChecked.current = true;

    if (
      !deeplinkToastConfig?.enabled ||
      canGoBack()
    ) {
      return;
    }

    const totalCount = parseInt(localStorage.getItem(DEEPLINK_TOAST_COUNT_KEY) || '0', 10);
    if (totalCount >= (deeplinkToastConfig.maxOccurrence || 0)) {
      return;
    }

    const lastShownTimestamp = Number(localStorage.getItem(DEEPLINK_TOAST_TIMESTAMP_KEY) || 0);
    const now = Date.now();
    const cooldownPeriodMs = deeplinkToastConfig.cooldownPeriodMs || 86400000;
    const periodElapsed = now - lastShownTimestamp >= cooldownPeriodMs;

    if (periodElapsed) {
      localStorage.setItem(DEEPLINK_TOAST_PERIOD_COUNT_KEY, '0');
      localStorage.setItem(DEEPLINK_TOAST_TIMESTAMP_KEY, String(now));
    }

    const periodCount = parseInt(localStorage.getItem(DEEPLINK_TOAST_PERIOD_COUNT_KEY) || '0', 10);
    const maxPerPeriod = deeplinkToastConfig.maxPerPeriod || 1;

    if (periodCount >= maxPerPeriod) {
      return;
    }

    localStorage.setItem(DEEPLINK_TOAST_COUNT_KEY, String(totalCount + 1));
    localStorage.setItem(DEEPLINK_TOAST_PERIOD_COUNT_KEY, String(periodCount + 1));
    setShowToast(true);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const dismiss = () => {
    setShowToast(false);
  };

  return {
    showDeeplinkToast: showToast,
    deeplinkToastConfig: deeplinkToastConfig,
    dismissDeeplinkToast: dismiss,
  };
}

export default useDeeplinkToast;
